import { jsx as _jsx } from "react/jsx-runtime";
import { Button } from '../../Controls/Button';
import Icons from '../../Elements/Icons';
export const getPlacement = (align, isSubmenu = false) => {
    if (isSubmenu) {
        // For submenus, use horizontal placement with top alignment
        switch (align) {
            case 'right':
                return 'right-start';
            case 'left':
                return 'left-start';
            default:
                return 'right-start';
        }
    }
    // For main menus, use vertical placement
    switch (align) {
        case 'right':
            return 'bottom-start';
        case 'left':
            return 'bottom-end';
        default:
            return 'bottom-start';
    }
};
export const stopPropagation = (e) => {
    e.stopPropagation();
};
export const renderMoreButton = (isShown) => (_jsx(Button, { secondary: true, iconOnly: true, children: _jsx(Icons.More, { size: 20, active: isShown }) }));
